import React, { useMemo } from 'react';
import { Box, Inscription } from '@common-fe/common-fe';

import { Renewal } from '../renewals.types';

import { StyledLink } from './styles/RenewalSetup.styles';

const RenewalSetupLinks: React.FC<{ renewalSetupData?: Renewal }> = ({ renewalSetupData }) => {
  const links = useMemo(() => ([
    {
      link: renewalSetupData?.pricingConsentLink,
      name: 'Pricing Consent',
    },
    {
      link: renewalSetupData?.privacyPolicyLink,
      name: 'Privacy Policy',
    },
    {
      link: renewalSetupData?.termsAndConditionsLink,
      name: 'Terms of Use',
    },
  ]).filter(item => item.link), [renewalSetupData]);

  if (!links.length) return null;

  return (
    <Box data-testId="renewal-setup-links" direction="row" margin={{ top: 'l' }} align="center" as="p">
      {links.map((item, idx) => (
        <React.Fragment key={item.name}>
          <StyledLink href={item.link} target="_blank" rel="noreferrer">
            {item.name}
          </StyledLink>
          {idx < links.length - 2 && <Inscription color="textBody">,&nbsp;</Inscription>}
          {idx === links.length - 2 && <Inscription color="textBody">&nbsp;and&nbsp;</Inscription>}
        </React.Fragment>
      ))}
      .
    </Box>
  );
};

export default RenewalSetupLinks;
